import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import React from 'react';
import { CellHeaderStyled, CellStyled } from './index.styles';

export function UsersTable() {
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <CellHeaderStyled>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Data do último pagamento</TableCell>
          </TableRow>
        </CellHeaderStyled>
        <TableBody>
          <CellStyled>
            <TableCell>MG Engenharia</TableCell>
            <TableCell>mgengenharia@gmail.com</TableCell>
            <TableCell className="date">23/11/2021</TableCell>
          </CellStyled>
          <CellStyled>
            <TableCell>FS Engenharia</TableCell>
            <TableCell>fsengenharia@gmail.com</TableCell>
            <TableCell className="date">24/10/2021</TableCell>
          </CellStyled>
          <CellStyled>
            <TableCell>AS Engenharia</TableCell>
            <TableCell>asengenharia@gmail.com</TableCell>
            <TableCell className="date">17/09/2021</TableCell>
          </CellStyled>
          <CellStyled>
            <TableCell>FS Engenharia</TableCell>
            <TableCell>fsengenharia@gmail.com</TableCell>
            <TableCell className="date">24/10/2021</TableCell>
          </CellStyled>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
